import React, { useEffect, useState } from "react";
import phone from "../../assets/images/phone-streaming.png";
import Header from "../layout/Header";
import { useNavigate } from "react-router-dom";

const Intro = () => {
  const navigate = useNavigate();
  const [name, setName] = useState(null);
  useEffect(() => {
    try {
      const rawName = sessionStorage.getItem("login_name");
      const name = rawName ? rawName.trim() : null;
      setName(name);
    } catch {}
  }, []);

  const gotoInstructions = () => {
    navigate("/instructions");
  };
  return (
    <div>
      <Header />
      <h1 className="green-font App">
        Hello, {name}! Welcome to the Solvo's Candidate Portal
      </h1>
      <p className="gray-font no-martop App">Let's get to know you better</p>
      <div className="flex fdir-row fjust-around rounded orange-bkg">
        <div className="flex fdir-col fver-center">
          <h2 className="white-font bold-font no-marbo">
            Your Career Starts Here
          </h2>
          <p className="white-font center-text">Record a video presentation</p>
          <div className="flex fver-center">
            <button onClick={gotoInstructions}>Get Started</button>
          </div>
        </div>
        <img
          alt="Mockup"
          style={{ height: "500px", padding: "1rem" }}
          src={phone}
        />
      </div>
    </div>
  );
};

export default Intro;
